module.exports = __webpack_public_path__ + "img/awards-rounded.01e1321.webp";